import React, { forwardRef } from 'react';

interface HomeFullProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const HomeFull = forwardRef<HTMLElement, HomeFullProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-house ${classes || ''}`} style={style}></i>
  );
});

HomeFull.displayName = 'HomeFull';
